import { NEXT_PUBLIC_DEBUG_LEVEL } from '@/shared/envs';
import { parseMusicXML } from './parse-musicxml/parse-musicxml';
import { useEffect, useState } from 'react';

export function dpAssert(condition: any, message?: string): asserts condition {
  if (!condition) {
    const error = new Error(message || 'Assertion failed');
    throw error;
  }
}

export enum logLevel {
  // when error occurs
  ERROR = 0,
  // when something is changed
  WARN = 1,
  // when function is called
  FUNCTION = 2,
  // flow of function
  FLOW = 3,
}

export function dpLog(debugLevel: logLevel, ...args: any[]) {
  dpAssert(NEXT_PUBLIC_DEBUG_LEVEL, "NEXT_PUBLIC_DEBUG_LEVEL is not set")
  if (debugLevel <= parseInt(NEXT_PUBLIC_DEBUG_LEVEL)) {
    console.log(...args);
  }
}

export const getMusicXml = async (sample: string | ArrayBuffer): Promise<string | null> => {
  return (
    await parseMusicXML(sample, {
      title: '//work/work-title/text()',
      version: '//score-partwise/@version',
    })
  ).musicXml;
};

export const useMobxObservable = (reaction: any): any => {
  const [state, setState] = useState(); 

  useEffect(() => {
    const disposer = window.mobx.reaction(
      reaction, 
      (newValue: any) => {
        setState(newValue); 
      }
    );

    return () => disposer();
  }, []);

  return state;
};